import React from 'react';
import { Link } from 'react-router-dom';
import { PHONE_DISPLAY, EMAIL, CITY } from '../constants';

const COLS = [
  {
    title: 'Quick Links',
    links: [
      ['Home', '/'],
      ['Courses', '/courses'],
      ['Syllabus', '/syllabus'],
      ['Course Registration', '/register'],
      ['Fees & Instructions', '/fees'],
    ],
  },
  {
    title: 'Our Courses',
    links: [
      ['Python + AI Course', '/python'],
      ['Web Development', '/webdev'],
      ['Combo Offer', '/fees'],
      ['View Syllabus', '/syllabus'],
    ],
  },
  {
    title: 'Company',
    links: [
      ['About Us', '/about'],
      ['Careers', '/careers'],
      ['Contact', '/contact'],
    ],
  },
];

export default function Footer() {
  const styles = {
    logo: {
      display: 'flex', alignItems: 'center', gap: 10,
      textDecoration: 'none',
    },
    logoText: {
      color: '#fff', fontWeight: 900, fontSize: 19,
      lineHeight: 1.4, fontFamily: 'cinzel decorative'
    },
    logoSub: {
      color: '#F0B429', fontSize: 10,
      fontWeight: 700, letterSpacing: '1.5px'
    },
  };

  return (
    <footer style={{ background: '#0d1f3c', color: 'rgba(255,255,255,0.72)', padding: '56px 24px 24px' }}>
      <div className="container">

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 36, marginBottom: 48 }}>

          {/* Brand column */}
          <div>
            <img src="/logo.png" alt="VRK Tech Academy" style={{ height: 130, borderRadius: 10 }} />
            <div style={{ marginTop: 16, maxWidth: 300, fontSize: 13, color: 'rgba(255,255,255,0.62)' }}>
              <div style={styles.logoText}>VRK Tech Academy</div>
              <div style={styles.logoSub}>SKILL · BUILD · FUTURE</div>
            </div>
          </div>

          {/* Link columns */}
          {COLS.map(({ title, links }) => (
            <div key={title}>
              <h4 style={{ color: '#fff', fontWeight: 800, marginBottom: 16, fontSize: 14, letterSpacing: '0.5px' }}>
                {title}
              </h4>
              {links.map(([label, path]) => (
                <div key={label} style={{ marginBottom: 10 }}>
                  <Link
                    to={path}
                    style={{
                      fontSize: 13,
                      color: 'rgba(255,255,255,0.62)',
                      textDecoration: 'none'
                    }}
                    onMouseEnter={e => (e.target.style.color = '#F0B429')}
                    onMouseLeave={e => (e.target.style.color = 'rgba(255,255,255,0.62)')}
                  >
                    {label}
                  </Link>
                </div>
              ))}
            </div>
          ))}

          {/* Contact column */}
          <div>
            <h4 style={{ color: '#fff', fontWeight: 800, marginBottom: 16, fontSize: 14 }}>Contact</h4>
            {[
              ['📱', 'Phone / WhatsApp', PHONE_DISPLAY],
              ['📧', 'Email', EMAIL],
              ['📍', 'Location', CITY],
              ['🕐', 'Hours', 'Mon–Sat: 9AM – 8PM'],
            ].map(([icon, label, value]) => (
              <div key={label} style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.45)', fontWeight: 700, letterSpacing: '0.5px' }}>
                  {icon} {label}
                </div>
                <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.75)', marginTop: 2 }}>
                  {value}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: 20,
          display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap',
          gap: 12, fontSize: 12, color: 'rgba(255,255,255,0.42)',
        }}>
          <span>© {new Date().getFullYear()} VRK Tech Academy. All rights reserved.</span>
          <span>Made with ❤️ for students and their futures</span>
        </div>
      </div>
    </footer>
  );
}
